import React, { useState, useEffect } from 'react';
import { products as allProducts } from '../mock/products';
import { getDolar } from '../utils/cart'; // Si tienes una función para obtener el dólar actual
import { supabase } from '../utils/supabase';

const TELEGRAM_TOKEN = "7871457521:AAE6s3TYc2oJk4PH_tHWD8-sCz3nIrjTR0I";
const TELEGRAM_CHAT_ID = "278131274"; // chat_id actualizado

async function notificarVentaTelegram(order) {
  const productos = order.items.map(p => `- ${p.name}${p.selectedColor ? ` (${p.selectedColor})` : ''} x${p.quantity}`).join("\n");
  const mensaje = `🛒 *¡Nueva venta en LT Celulares!*\n\n*Cliente:* ${order.customer.name} ${order.customer.lastName}\n*Teléfono:* ${order.customer.phone}\n*Dirección:* ${order.customer.address}\n*DNI:* ${order.customer.dni}\n\n*Productos:*\n${productos}\n\n*Total:* $${order.total.toLocaleString('es-AR')}\nFecha: ${new Date(order.date).toLocaleString('es-AR')}`;  // <-- Cambiado de created_at a date
  await fetch(`https://api.telegram.org/bot${TELEGRAM_TOKEN}/sendMessage`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      chat_id: TELEGRAM_CHAT_ID,
      text: mensaje,
      parse_mode: 'Markdown'
    })
  });
}

// Funciones para manejar cookies
function setCookie(name, value, days = 365) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
}
function getCookie(name) {
  return document.cookie.split('; ').reduce((r, v) => {
    const parts = v.split('=');
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, '');
}

const CheckoutForm = ({ cartItems, total, onComplete, onCancel }) => {
  // Al iniciar, intentar autocompletar desde cookies
  const [formData, setFormData] = useState({
    name: getCookie('buyer_name') || '',
    lastName: getCookie('buyer_lastName') || '',
    dni: getCookie('buyer_dni') || '',
    address: getCookie('buyer_address') || '',
    phone: getCookie('buyer_phone') || ''
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'El nombre es requerido';
    }
    
    if (!formData.lastName.trim()) {
      newErrors.lastName = 'El apellido es requerido';
    }
    
    if (!formData.dni.trim()) {
      newErrors.dni = 'El DNI es requerido';
    } else if (formData.dni.length < 7) {
      newErrors.dni = 'El DNI debe tener al menos 7 dígitos';
    }
    
    if (!formData.address.trim()) {
      newErrors.address = 'La dirección es requerida';
    }
    
    if (!formData.phone.trim()) {
      newErrors.phone = 'El teléfono es requerido';
    } else if (formData.phone.length < 10) {
      newErrors.phone = 'El teléfono debe tener al menos 10 dígitos';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Limpiar error del campo cuando el usuario empiece a escribir
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  // Obtener el próximo ID de compra desde localStorage o iniciar en 1000
  function getNextOrderId() {
    const lastId = parseInt(localStorage.getItem('lastOrderId') || '999', 10);
    const nextId = lastId + 1;
    localStorage.setItem('lastOrderId', nextId);
    return nextId;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      // Guardar datos en cookies para autocompletar en el futuro
      setCookie('buyer_name', formData.name);
      setCookie('buyer_lastName', formData.lastName);
      setCookie('buyer_dni', formData.dni);
      setCookie('buyer_address', formData.address);
      setCookie('buyer_phone', formData.phone);
      // Obtener el dólar actual desde la base de datos
      let dolarUsado = 1250; // Valor por defecto
      try {
        const { data: dolarData, error: dolarError } = await supabase
          .from('dolar')
          .select('valor')
          .order('id', { ascending: false })
          .limit(1);
        
        if (!dolarError && dolarData && dolarData.length > 0) {
          dolarUsado = dolarData[0].valor;
        }
      } catch (error) {
        console.error('Error obteniendo valor del dólar:', error);
      }
      // Crear la orden
      const order = {
        id: getNextOrderId(), // ID incremental desde 1000
        customer: formData,
        items: cartItems.map(item => ({
          ...item,
          serialNumber: '',
          priceusd: item.priceusd !== undefined ? item.priceusd : 0,
          costusd: item.costusd !== undefined ? item.costusd : 0
        })),
        total: total,
        date: new Date().toISOString(),  // <-- Cambiado de created_at a date
        status: 'pending',
        dolarusado: dolarUsado
      };
      
      // Guardar en Supabase
      const { data, error } = await supabase
        .from('orders')
        .insert([
          order
        ]);
      if (error) {
        alert('Error guardando el pedido en Supabase');
        console.error(error);
        setIsSubmitting(false);
        return;
      }
      // Notificar a Telegram
      await notificarVentaTelegram(order);
      // Simular envío (en producción esto sería una API)
      await new Promise(resolve => setTimeout(resolve, 1500));
      onComplete(order);
    } catch (error) {
      console.error('Error al procesar la orden:', error);
      alert('Hubo un error al procesar tu orden. Por favor, intenta nuevamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900">Finalizar Compra</h2>
            <button
              onClick={onCancel}
              className="text-gray-500 hover:text-gray-700 p-1 rounded-full transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          {/* Resumen de la compra */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <h3 className="font-medium text-gray-900 mb-3">Resumen de tu compra</h3>
            <div className="space-y-2">
              {cartItems.map((item, index) => (
                <div key={index} className="flex justify-between text-sm">
                  <span className="text-gray-600">
                    {item.name} {item.selectedColor && `(${item.selectedColor})`} x{item.quantity}
                  </span>
                  <span className="font-medium">
                    ${(item.pricears * item.quantity).toLocaleString('es-AR')}
                  </span>
                </div>
              ))}
              <div className="border-t pt-2 flex justify-between font-bold text-lg">
                <span>Total</span>
                <span>${total.toLocaleString('es-AR')}</span>
              </div>
            </div>
          </div>
          
          {/* Formulario */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                  Nombre *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-colors ${
                    errors.name ? 'border-red-500' : 'border-gray-300'
                  }`}
                  placeholder="Tu nombre"
                />
                {errors.name && (
                  <p className="text-red-500 text-xs mt-1">{errors.name}</p>
                )}
              </div>
              
              <div>
                <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1">
                  Apellido *
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-colors ${
                    errors.lastName ? 'border-red-500' : 'border-gray-300'
                  }`}
                  placeholder="Tu apellido"
                />
                {errors.lastName && (
                  <p className="text-red-500 text-xs mt-1">{errors.lastName}</p>
                )}
              </div>
            </div>
            
            <div>
              <label htmlFor="dni" className="block text-sm font-medium text-gray-700 mb-1">
                DNI *
              </label>
              <input
                type="text"
                id="dni"
                name="dni"
                value={formData.dni}
                onChange={handleInputChange}
                className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-colors ${
                  errors.dni ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="12345678"
              />
              {errors.dni && (
                <p className="text-red-500 text-xs mt-1">{errors.dni}</p>
              )}
            </div>
            
            <div>
              <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                Teléfono *
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-colors ${
                  errors.phone ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="11 1234-5678"
              />
              {errors.phone && (
                <p className="text-red-500 text-xs mt-1">{errors.phone}</p>
              )}
            </div>
            
            <div>
              <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-1">
                Dirección *
              </label>
              <textarea
                id="address"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                rows="3"
                className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-colors ${
                  errors.address ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="Calle, número, ciudad, provincia"
              />
              {errors.address && (
                <p className="text-red-500 text-xs mt-1">{errors.address}</p>
              )}
            </div>
            
            <div className="flex space-x-3 pt-4">
              <button
                type="button"
                onClick={onCancel}
                className="flex-1 py-3 px-4 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium"
              >
                Cancelar
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="flex-1 py-3 px-4 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'Procesando...' : 'Confirmar Compra'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CheckoutForm; 